module.exports = ".booking-info {\n\n}\n.booking-info ul {\n    margin-left: 20px;\n}"